import { shareListModalStyles } from "@insite/content-library/Components/ShareListModal";
import { RadioStyle } from "@insite/mobius/Radio";
import { COLORS, TYPOGRAPHY } from "@store/theme/common/design";
import { css } from "styled-components";

Object.assign(shareListModalStyles, {
    shareListOptionRadioGroup: {
        css: css`
            flex-direction: column;
            & > ${RadioStyle} {
                margin-top: 10px;
            }
        `,
    },
    recipientEmailTooltip: {
        cssOverrides: {
            tooltipWrapper: css`
                margin-left: 5px;
            `,
            tooltipContainer: css`
                margin-left: -170px;
                &::after {
                    left: 170px;
                }
            `,
        },
        typographyProps: {
            weight: TYPOGRAPHY.weight.base,
        },
    },
    shareByOptionText: {
        color: COLORS.text.base,
        weight: TYPOGRAPHY.weight.bold,
    },
    shareListOptionText: {
        color: COLORS.text.base,
        weight: TYPOGRAPHY.weight.bold,
    },
    yourNameTextField: {
        labelProps: {
            css: css`
                margin-bottom: 3px;
            `,
        },
    },
    shareByOptionRadioGroup: {
        css: css`
            flex-direction: column;
        `,
    },
    // reset radio styles
    sendCopyRadio: {},
    shareListRadio: {},
    shareByBillingRadio: {},
    shareByEmailRadio: {},
});
